
  import React from "react"
  import Component from "C:/Users/Guzman/Workspace/invent-and-thrive/src/layouts/index.js"
  import data from "C:\\Users\\Guzman\\Workspace\\invent-and-thrive\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js